// extracted by mini-css-extract-plugin
export default {"cls1":"gaNmxzSNuhsm3CQYDvHb","cls2":"L13_z7WLSheYRkAHQ3Po gaNmxzSNuhsm3CQYDvHb"};